export const appConstants = {
  RESET: 'APP_RESET',
};
